import React, { useState } from "react";

import DrawerPortfolio from "@/components/MobileLayout/Drawers/Portfolio";
import { BrowseDrawer } from "@/components/MobileLayout/Drawers/Browse";
import { MoreDrawer } from "@/components/MobileLayout/Drawers/More";
import { MobileLayoutDrawersRightSidebar } from "@/components/MobileLayout/Drawers/RightSidebar";
import { NavItem } from "@/components/MobileLayout/Menu/NavItem";

import { usePathname } from "next/navigation";
import { SupCoin, SupDotsHorizontalRounded, SupInsights, SupShoppingBagActive } from "@repo/core-ui";
import { useStoredDataDispatch } from "@/store";
import { Icons } from "@/components/Cred/UI/Icon";

const BROWSE_PATHS = ["/vaults", "/protocols", "/explore", "/piggy"];
const PORTFOLIO_PATHS = ["/portfolio", "/activity"];
const CRED_PATHS = ["/rewards", "/season1", "/season2"];

export default function MobileLayoutBar() {
  const storedDispatch = useStoredDataDispatch();
  const currentPath = usePathname();
  const [browseVisible, setBrowseVisibility] = useState(false);
  const [moreVisible, setMoreVisibility] = useState(false);
  const [portfolioVisible, setPortfolioVisibility] = useState(false);

  return (
    <div className="fixed inset-x-0 bottom-0 bg-neutral-50 md:hidden">
      <nav className="flex h-12">
        <NavItem
          active={BROWSE_PATHS.some(path => currentPath.startsWith(path))}
          icon={<SupCoin />}
          title="Earn"
          className="flex-1"
          onClick={() => {
            setBrowseVisibility(true);
          }}
        />

        <NavItem
          onClick={() => {
            setPortfolioVisibility(true);
          }}
          active={PORTFOLIO_PATHS.some(path => currentPath.startsWith(path))}
          icon={<SupInsights />}
          title="Portfolio"
          className="flex-1"
        />

        <NavItem
          useATag
          href="/rewards/"
          active={CRED_PATHS.some(path => currentPath.startsWith(path))}
          icon={<Icons.sparkles className="h-5 w-5" />}
          title="Rewards"
          className="flex-1"
        />

        <NavItem
          icon={<SupShoppingBagActive />}
          title="Bag"
          className="flex-1"
          onClick={() => {
            storedDispatch({ type: "setOverlay", overlay: "deposit" });
          }}
        />

        <NavItem
          icon={<SupDotsHorizontalRounded />}
          title="More"
          className="flex-1"
          onClick={() => {
            setMoreVisibility(true);
          }}
        />
      </nav>

      <BrowseDrawer
        unmount
        open={browseVisible}
        orientation="bottom"
        onClose={() => {
          setBrowseVisibility(false);
        }}
      />

      <DrawerPortfolio
        unmount
        open={portfolioVisible}
        orientation="bottom"
        onClose={() => {
          setPortfolioVisibility(false);
        }}
      />

      <MoreDrawer
        unmount
        open={moreVisible}
        orientation="bottom"
        onClose={() => {
          setMoreVisibility(false);
        }}
      />

      <MobileLayoutDrawersRightSidebar />
    </div>
  );
}
